import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-275602d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "verify-row"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { marginLeft: '-4px' } }, "未认证", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "verify-text" }, "去认证", -1));
const _hoisted_5 = { class: "verify-icon" };
const _hoisted_6 = {
    key: 1,
    class: "verify-row"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "个人认证", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "verify-text" }, "升级为企业认证", -1));
const _hoisted_9 = { class: "verify-icon" };
const _hoisted_10 = {
    key: 2,
    class: "verify-row"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, null, -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { style: { marginLeft: '-4px' } }, "认证审核中", -1));
const _hoisted_13 = {
    key: 3,
    class: "verify-row"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "企业认证", -1));
import CloudTag from "@/components/CloudTag/index.vue";
import { VERIFY_TYPE_VALUE } from "@/types/personal";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    name: 'VerifyType',
    props: {
        verifyType: { default: 0 },
        isShow: { type: Boolean, default: false }
    },
    emits: ["personal"],
    setup(__props, { emit }) {
        const router = useRouter();
        const goPersonalVerify = () => {
            emit("personal");
        };
        const goEnterpriseVerify = () => {
            router.push({
                path: "verify"
            });
        };
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['未认证'] ||
                __props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证审核不通过'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(CloudTag, null, {
                        icon: _withCtx(() => [
                            _hoisted_2
                        ]),
                        default: _withCtx(() => [
                            _hoisted_3
                        ]),
                        _: 1
                    }),
                    (!__props.isShow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "verify-button",
                            onClick: goPersonalVerify
                        }, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_svg_icon, { "icon-class": "arrow" })
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人认证'] ||
                    __props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人升级企业审核不通过'])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(CloudTag, {
                            class: "master-style",
                            icon: "status_personal"
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7
                            ]),
                            _: 1
                        }),
                        (!__props.isShow)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "verify-button",
                                onClick: goEnterpriseVerify
                            }, [
                                _hoisted_8,
                                _createElementVNode("div", _hoisted_9, [
                                    _createVNode(_component_svg_icon, { "icon-class": "arrow" })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证待审核'] ||
                        __props.verifyType === _unref(VERIFY_TYPE_VALUE)['个人升级企业待审核'])
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(CloudTag, { class: "warning-style" }, {
                                icon: _withCtx(() => [
                                    _hoisted_11
                                ]),
                                default: _withCtx(() => [
                                    _hoisted_12
                                ]),
                                _: 1
                            })
                        ]))
                        : (__props.verifyType === _unref(VERIFY_TYPE_VALUE)['企业认证'])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createVNode(CloudTag, {
                                    class: "master-style",
                                    icon: "status_business"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_14
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true);
        };
    }
});
